// types 

export const SHOW_LEFT_MENU = "SHOW_LEFT_MENU";
export const HIDE_LEFT_MENU = "HIDE_LEFT_MENU";

// Actions

export const showLeftMenu = () => { return { type: SHOW_LEFT_MENU, payload: { visible: true  }}}
export const hideLeftMenu = () => { return { type: HIDE_LEFT_MENU, payload: { visible: false }}} 